<section class="main-setup">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-6 mb-3">
        <div class="setup__content">
          <div class="row justify-content-center mb-2 pb-3">
            <img src="assets/logos/logo-inprovider.png" alt="" class="imgSizes">
          </div>

          @if (!tokenChecked) {
            <div class="text-center">
              <p>Validando invitación...</p>
            </div>
          }

          @if (tokenChecked && !tokenValid) {
            <div class="text-center">
              <div class="alert alert-danger">{{ errorMessage }}</div>
              <p>Contacta al administrador para solicitar una nueva invitación.</p>
            </div>
          }

          @if (tokenChecked && tokenValid) {
            <div class="text-center mb-4">
              <h4>Configura tu cuenta</h4>
              <p class="text-muted">Hola <strong>{{ userName }}</strong>, configura tu contraseña para acceder a tu cuenta.</p>
            </div>

            @if (successMessage) {
              <div class="alert alert-success">{{ successMessage }}</div>
            }
            @if (errorMessage) {
              <div class="alert alert-danger">{{ errorMessage }}</div>
            }

            <form [formGroup]="setupForm" (ngSubmit)="onSubmit()">
              <div class="form-group mb-3">
                <label class="labeltext">Contraseña</label>
                <input class="form-control" type="password" placeholder="Mínimo 8 caracteres" formControlName="password">
                @if (setupForm.controls['password'].touched && setupForm.controls['password'].errors?.['required']) {
                  <div class="texterror">Contraseña requerida</div>
                }
                @if (setupForm.controls['password'].touched && setupForm.controls['password'].errors?.['minlength']) {
                  <div class="texterror">Mínimo 8 caracteres</div>
                }
              </div>

              <div class="form-group mb-4">
                <label class="labeltext">Confirmar Contraseña</label>
                <input class="form-control" type="password" placeholder="Confirmar contraseña" formControlName="confirmpassword">
                @if (setupForm.controls['confirmpassword'].touched && setupForm.controls['confirmpassword'].errors?.['required']) {
                  <div class="texterror">Confirmar contraseña requerida</div>
                }
                @if (setupForm.controls['confirmpassword'].errors?.['matchOther'] && !setupForm.controls['confirmpassword'].errors?.['required']) {
                  <div class="texterror">Las contraseñas deben coincidir</div>
                }
              </div>

              <div class="oauth-section mb-4">
                <p class="labeltext text-center mb-3">Vincular cuentas (opcional)</p>
                <div class="d-flex justify-content-center gap-3">
                  <button type="button" class="btn btn-outline-secondary oauth-btn" (click)="linkGoogle()" [disabled]="!!googleId">
                    <i class="fab fa-google"></i>
                    {{ googleId ? '✓ Google vinculado' : 'Vincular Google' }}
                  </button>
                  <button type="button" class="btn btn-outline-secondary oauth-btn" (click)="linkMicrosoft()" [disabled]="!!microsoftId">
                    <i class="fab fa-microsoft"></i>
                    {{ microsoftId ? '✓ Microsoft vinculado' : 'Vincular Microsoft' }}
                  </button>
                </div>
                @if (googleId) {
                  <div class="text-center mt-2">
                    <a class="small text-muted" style="cursor:pointer" (click)="unlinkGoogle()">Desvincular Google</a>
                  </div>
                }
                @if (microsoftId) {
                  <div class="text-center mt-2">
                    <a class="small text-muted" style="cursor:pointer" (click)="unlinkMicrosoft()">Desvincular Microsoft</a>
                  </div>
                }
              </div>

              <button type="submit" class="btn btn-outline-primary rounded-pill px-5 mx-auto d-block" [disabled]="setupForm.invalid || submitting">
                {{ submitting ? 'Configurando...' : 'Configurar cuenta' }}
              </button>
            </form>
          }
        </div>
      </div>
    </div>
  </div>
</section>
